import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Hero } from './components/Hero';
export function App() {
  return <>
      <Helmet data-id="element-0">
        <title data-id="element-1">Dilbert Ratio Group - AI Automation That Drives Profit</title>
        <meta name="description" content="Your fractional AI automation team for revenue, efficiency, and consistency at scale. Partners in automation, outcomes on autopilot." data-id="element-2" />
        <meta property="og:title" content="Dilbert Ratio Group - AI Automation That Drives Profit" data-id="element-3" />
        <meta property="og:description" content="Your fractional AI automation team for revenue, efficiency, and consistency at scale. Partners in automation, outcomes on autopilot." data-id="element-4" />
        <meta property="og:type" content="website" data-id="element-5" />
        <meta name="twitter:card" content="summary_large_image" data-id="element-6" />
        <meta name="twitter:title" content="Dilbert Ratio Group - AI Automation That Drives Profit" data-id="element-7" />
        <meta name="twitter:description" content="Your fractional AI automation team for revenue, efficiency, and consistency at scale. Partners in automation, outcomes on autopilot." data-id="element-8" />
      </Helmet>
      <div className="w-full min-h-screen bg-black" data-id="element-9">
        <Hero data-id="element-10" />
      </div>
    </>;
}